import React, { useEffect, useState } from 'react';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
import { CallToAction } from 'components/atoms/callToAction';
import Dotdotdot from 'react-dotdotdot';
import './styles.scss';
import { Image } from 'components/atoms/image';

const TeamMobileCard = props => {
  const data = props.data;
  const detailsPage = props.detailsPage;
  const [selected_name, set_selected_name] = useState('');
  const [selected_title, set_selected_title] = useState('');
  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);
  const [overlay_page_data, set_overlay_page_data] = useState({});
  const thumbnailUrl = `${props.mediaPath.thumbnail}/${props.imagePath}`;
  useEffect(() => {
    if (detailsPage) {
      checkOverlayCorrespondingFeature();
    }
  }, [selected_name]);
  const mediaPath = `${props.mediaPath.mobile}`;
  const checkOverlayCorrespondingFeature = () => {
    let overlaydata = {};
    set_overlay_page_data(overlaydata);
    Object.values(detailsPage).map((cmsdata, idx) => {
      if (props.data.name === cmsdata.page_title) {
        set_overlay_page_data(cmsdata);
        set_selected_title(cmsdata.page_title);
        return;
      }
    });
  };
  const handleLearnMore = name => {
    set_selected_name(name);
    checkOverlayCorrespondingFeature();
    setshowDescriptionLayout(true);
  };
  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={overlay_page_data}
        theme={'light-theme'}
        type={'leadership-mobile-overlay'}
        openFor={'leadershipMobile'}
        mediaPath={mediaPath}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'About',
            breadcrumbLink: RouteNames.homes,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;
  return (
    <div className="mobile-team-card">
      <div
        onClick={() =>
          props.showOverlay === true && data.name === selected_title
            ? handleLearnMore(data.name)
            : null
        }
      >
        <div className="mobile-team">
          <Image
            className="mobile-team-img"
            src={`${mediaPath}/${props.imagePath}`}
            thumbNail={thumbnailUrl}
            alt="Team member"
          />
        </div>
        <h1 className="team-name">{props.data.name}</h1>
        <h4 className="team-member-role">{data.member_role}</h4>
      </div>
      <div className="box-align">
        {props.showOverlay === true ? (
          <Dotdotdot clamp={2} tagName={'div'}>
            <h4 className="team-description">
              {props.data.member_mobile_description}
            </h4>
          </Dotdotdot>
        ) : (
          <Dotdotdot clamp={4} tagName={'div'}>
            <h4 className="team-description">
              {props.data.member_mobile_description}
            </h4>
          </Dotdotdot>
        )}
        {props.showOverlay === true && data.name === selected_title ? (
          <div className="explore-button">
            <CallToAction
              onClick={() => handleLearnMore(props.data.name)}
              text={'Learn More'}
              mode={'transparent'}
              type={'link'}
              size={'small'}
            />
          </div>
        ) : null}
      </div>
      {showOverlay}
    </div>
  );
};
export default TeamMobileCard;
